import { memo } from 'react'
import { SharingDialogStage } from '@tabeeb/modules/contentSharings/types'
import { DialogTitle, Header3 } from '@collaborate-health/uikit'
import { Step, StepButton, Stepper } from '@mui/material'

interface TitleProps {
  stages: SharingDialogStage[]
  currentStageIndex: number
  setCurrentStageIndex: (index: number) => void
}

const Title: React.FC<TitleProps> = ({ stages, setCurrentStageIndex, currentStageIndex }) => {
  if (stages?.length < 1) {
    return null
  }

  return (
    <DialogTitle>
      {stages.length > 1 ? (
        <Stepper nonLinear activeStep={currentStageIndex}>
          {stages.map((stage, index) => (
            <Step key={stage.label} completed={stage.isCompleted}>
              <StepButton color='inherit' onClick={() => setCurrentStageIndex(index)}>
                {stage.label}
              </StepButton>
            </Step>
          ))}
        </Stepper>
      ) : (
        <Header3>{stages[0].label}</Header3>
      )}
    </DialogTitle>
  )
}

export default memo(Title)

